import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings')({
    staticData: {
        breadcrumb: {
            title: 'Organisation settings',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Building2,
        },
    },
    component: Outlet,
});
